import axios from "../../axios";

export const getProgramScopeHierarchical = async (programId: number) => {
    try {
        const response = await axios.get(`/v2/programs/${programId}/scope-hierarchical`);
        return response.data;
    } catch (error) {
        console.error("Error fetching hierarchical scope:", error);
        throw error;
    }
};

export const getProgramScopeWithSnapshots = async (programId: number) => {
    try {
        const response = await axios.get(`/v2/programs/${programId}/scope-with-snapshots`);
        return response.data;
    } catch (error) {
        console.error("Error fetching scope with snapshots:", error);
        throw error;
    }
};
